<template>
    <div class="subscribe-component">
        <h1 class="pt-0">Choose your membership</h1>

        <div class="text-center mb-4 toggle central-toggle">
            <label class="d-flex justify-content-center align-items-center text-white">
                <span class="toggle-label">Monthly</span>
                <b-form-checkbox
                    v-model="selectedTerm"
                    name="subscription-term-switch"
                    switch
                    size="lg"
                    :value="'annual'"
                    :unchecked-value="'monthly'"
                ></b-form-checkbox>
                <span class="toggle-label">Annual (save 33%)</span>
            </label>
        </div>

        <div class="container">
            <div class="row">
                <!-- Plan Details -->
                <div class="col-lg-4 col-md-12 mb-4">
                    <div class="benefits mt-2 h-100">
                        <div class="mb-4">
                            <h3>Free</h3>
                            <p>A selection of bitesized classes to get you started.</p>
                            <h3>
                                £0<small>&nbsp;</small>
                                <br>
                                <small>&nbsp;</small>
                            </h3>
                        </div>

                        <template v-if="currentTier == 'freemium'">
                            <div class="text-center text-bold mb-4 d-flex justify-content-center align-items-center" style="min-height: 50px;">
                                <p class="mb-0"><em>Your current plan {{ isDowngrade ? 'until ' + downgradeDateFormatted : '' }}</em></p>
                            </div>
                        </template>
                        <template v-else>
                            <button class="btn btn-primary btn-block mb-4" @click="selectPlan('freemium')">{{ freemiumButtonText }}</button>
                        </template>

                        <ul class="nopad benefits-list">
                            <li>100 bitesized classes with Artists and Industry</li>
                            <li>Make your own playlists of Classes</li>                            
                        </ul>
                    </div>
                </div>
                
                <div class="col-lg-4 col-md-12 mb-4">
                    <div class="benefits mt-2 h-100">
                        <div class="mb-4">
                            <h3>Essentials</h3>
                            <p>Access to bitesized classes with artists and industry.</p>
                            <h3>
                                <template v-if="selectedTerm == 'monthly'">
                                    £{{ monthlyEssentials.planPrice.price }}<small>/month</small><br>
                                    <small>£{{ (monthlyEssentials.planPrice.price*12).toFixed(0) }} total /yr</small>
                                </template>
                                <template v-else>
                                    <span class="old-price">£{{ monthlyEssentials.planPrice.price }}</span>
                                    £{{ (Math.floor((annualEssentials.planPrice.price/12) * 100) / 100).toFixed(2) }}<small>/month</small><br>
                                    <small class="text-success">Save £{{ ((monthlyEssentials.planPrice.price * 12) - annualEssentials.planPrice.price).toFixed(0) }}/yr</small>
                                </template>
                            </h3>
                        </div>

                        <template v-if="currentTier == 'essentials'">
                            <div class="text-center text-bold mb-4 d-flex justify-content-center align-items-center" style="min-height: 50px;">
                                <p class="mb-0"><em>Your current plan {{ isDowngrade ? 'until ' + downgradeDateFormatted : '' }}</em></p>
                            </div>
                        </template>
                        <template v-else>
                            <button class="btn btn-primary btn-block mb-4" @click="selectPlan('essentials')">{{ buttonText }}</button>
                        </template>

                        <ul class="nopad benefits-list">
                            <li>Unlimited access to bitesized classes with Artists and Industry</li>
                            <li>New Classes added each week</li>
                            <li>Make your own class playlists</li>
                            <li>No strings. Cancel anytime</li>
                        </ul>
                    </div>
                </div>
                
                <div class="col-lg-4 col-md-12 mb-4">
                    <div class="benefits mt-2 h-100">
                        <div class="mb-4">
                            <h3>Premium</h3>
                            <p>All classes, full courses and discounts on music feedback.</p>
                            <h3>
                                <template v-if="selectedTerm == 'monthly'">
                                    £{{ monthly.planPrice.price }}<small>/month</small><br>
                                    <small>£{{ (monthly.planPrice.price*12).toFixed(0) }} total /yr</small>
                                </template>
                                <template v-else>
                                    <span class="old-price">£{{ monthly.planPrice.price }}</span>
                                    £{{ (Math.floor((annual.planPrice.price/12) * 100) / 100).toFixed(2) }}<small>/month</small><br>
                                    <small class="text-success">Save £{{ ((monthly.planPrice.price * 12) - annual.planPrice.price).toFixed(0) }}/yr</small>
                                </template>
                            </h3>
                        </div>

                        <template v-if="currentTier == 'premium'">
                            <div class="text-center text-bold mb-4 d-flex justify-content-center align-items-center" style="min-height: 50px;">
                                <p class="mb-0"><em>Your current plan {{ isDowngrade ? 'until ' + downgradeDateFormatted : '' }}</em></p>
                            </div>
                        </template>
                        <template v-else>
                            <button class="btn btn-primary btn-block mb-4" @click="selectPlan('premium')">{{ buttonText }}</button>
                        </template>

                        <ul class="nopad benefits-list">
                            <li>Everything in Essentials, plus:</li>
                            <li>Full-length artist Courses</li>
                            <li>Course guide downloads</li>
                            <li>Discounts on Artist music feedback and assessments</li>
                            <li>No strings. Cancel anytime</li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        monthly: {
            type: Object,
            required: false,
        },
        annual: {
            type: Object,
            required: false,
        },
        monthlyEssentials: {
            type: Object,
            required: false,
        },
        annualEssentials: {
            type: Object,
            required: false,
        },
        currentTier: {
            type: String,
            required: false,
        },
        returnUrl: {
            type: String,
            required: true,
        },
        isDowngrade: {
            type: Boolean,
            required: false,
        },
        downgradeDateFormatted: {
            type: String,
            required: false,
        }
    },

    data() {
        return {            
            isAuth: false,
            isVerified: false,
            isSubscribed: false,
            user: {},
            selectedTerm: 'monthly',
        };
    },

    computed: {
        registerUrl() {
            if (this.returnUrl && this.returnUrl.length > 0) {
                return `/register?via=/subscribe&return=${encodeURIComponent(this.returnUrl)}`;
            }
            return `/register?return=/subscribe`;
        },

        isSubscribed() {
            return this.currentTier && this.currentTier !== '' && this.currentTier !== 'freemium';
        },

        buttonText() {
            return this.isSubscribed ? 'Switch Plan' : 'Buy Now';
        },

        freemiumButtonText() {
            return this.isSubscribed ? 'Switch Plan' : 'Get Started';
        }
    },

    mounted() {        
        // User logged in?
        if (window.virtuoso) {
            if (window.virtuoso.is_auth) {
                this.isAuth = true;
                this.isVerified = window.virtuoso.is_verified;
                this.isSubscribed = window.virtuoso.is_subscribed;
                this.user = window.virtuoso.user;
            }
        }
    },

    methods: {
        selectPlan(plan) {
            if(!this.isAuth) {
                location.href = this.registerUrl;
                return;
            }

            let baseUrl = '/subscribe/' + plan + '/' + this.selectedTerm;

            if (this.returnUrl && this.returnUrl.length > 0) {
                baseUrl += `?return=${encodeURIComponent(this.returnUrl)}`;
            }

            // Is user is logged in but not on freemium, and they request freemium, take them to cancellation flow
            if(this.isAuth && this.currentTier !== 'freemium' && plan === 'freemium') {
                baseUrl = '/billing/cancel-feedback';
            }

            location.href = baseUrl;
        }
    }
}
</script>